import React, { createContext, useContext } from 'react';
import { useToast } from '../components/shared/Toast';

const ToastContext = createContext();

export const useToastContext = () => {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error('useToastContext must be used within a ToastProvider');
  }
  return context;
};

export const ToastProvider = ({ children }) => {
  const toast = useToast();

  /** @param {string} message @param {'success'|'error'|'warning'|'info'} [type] */
  const showToast = (message, type = 'info', options = {}) => {
    if (message == null || message === '') return;
    toast.addToast({
      type,
      message: String(message),
      duration: 5000,
      ...options,
    });
  };

  return (
    <ToastContext.Provider value={{ ...toast, showToast }}>
      {children}
    </ToastContext.Provider>
  );
};
